import { createContext } from "react";
import { Configuration } from "../../../domain/adapters/configuration";

export const ConfigurationContext = createContext<Configuration | null>(null);
